 /*******************分销管理***************/
const part = resolve => require(['@/pages/retailStore/part'], resolve);//角色管理
const upgradeRules = resolve => require(['@/pages/retailStore/upgradeRules'], resolve);//升级规则
const updateRules = resolve => require(['@/pages/retailStore/upgradeRules/updateRules'], resolve);//升级规则修改
const rewardAllocation = resolve => require(['@/pages/retailStore/rewardAllocation'], resolve);//全局奖励配置
const shop = resolve => require(['@/pages/retailStore/shop'], resolve);
const shopAwardConfig = resolve => require(['@/pages/retailStore/shop/awardConfig'], resolve);
const newPlus = resolve => require(['@/pages/retailStore/newPlus'], resolve);
const awardConfig = resolve => require(['@/pages/retailStore/newPlus/awardConfig'], resolve);
const distr = resolve => require(['@/pages/retailStore/distr'], resolve);
const distrAwardConfig = resolve => require(['@/pages/retailStore/distr/awardConfig'], resolve);
export default [{
    path: "/retail/part",
    name: "角色管理",
    component: part
  },{
    path: "/retail/upgradeRules",
    name: "升级规则",
    component: upgradeRules
  },{
    path: "/retail/updateRules",
    name: "升级规则设置",
    component: updateRules
  },{
    path: "/retail/rewardAllocation",
    name: "升级规则设置",
    component: rewardAllocation
  },
  {
    path: "/retail/shop",
    name: "店铺管理",
    component: shop,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/retail/shop/awardConfig/:storeId",
    name: "店铺奖励管理",
    component: shopAwardConfig
  },
  {
    path: "/retail/newPlus",
    name: "商品管理",
    component: newPlus,
    meta: {
      keepAlive: true
    }
  },{
    path: "/retail/newPlus/awardConfig/:novaItemId/:itemId",
    name: "奖项配置",
    component: awardConfig
  },{
    path: "/retail/distr",
    name: "商品管理",
    component: distr,
    meta: {
      keepAlive: true
    }
  },{
    path: "/retail/distr/awardConfig/:novaItemId/:itemId",
    name: "奖项配置",
    component: distrAwardConfig
  }]
  